module.exports = __webpack_public_path__ + "static/media/019.d61ee940.jpg";